// extracted by mini-css-extract-plugin
export default {"container":"UserStatusPage_container__DfP3V","filesContent":"UserStatusPage_filesContent__ljVax","lien":"UserStatusPage_lien__Pcm+g"};